export default function SectionTitle({ eyebrow, title, subtitle, light = false, align = "left" }) {
    const textColor = light ? "text-white" : "text-[#1a1a1a]";
    const subColor = light ? "text-white/70" : "text-[#4a4a4a]";
    const alignClass = align === "center" ? "text-center mx-auto" : "text-left";

    return (
        <div className={`max-w-3xl ${alignClass}`}>
            {eyebrow && (
                <p className="inline-block text-xs uppercase tracking-[0.3em] font-bold text-[#fec200] mb-4 border-l-4 border-[#fec200] pl-3">
                    {eyebrow}
                </p>
            )}
            <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight leading-tight ${textColor}`}>
                {title}
            </h2>
            {subtitle && (
                <p className={`mt-5 text-base sm:text-lg leading-relaxed ${subColor}`}>
                    {subtitle}
                </p>
            )}
        </div>
    );
}
